import ModuleSwitchGrid from "./ModuleSwitchGrid.component";

export default ModuleSwitchGrid;
